module.exports = __webpack_public_path__ + "img/style_2_0.821c7a2a.png";